import req from '@sportninja/common/api/request'

/**
 * Updates a player's attendance to mark them as bringing refreshments.
 * @param gameId - The game ID
 * @param rosterId - The roster ID
 * @param playerId - The player ID
 */
export const updatePlayerRefreshments = async (
  gameId: string,
  rosterId: string,
  playerId: string
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/players/${playerId}/attendance`,
    {
      method: 'PUT',
      body: JSON.stringify({
        bringing_refreshments: true,
      }),
    }
  )
}

/**
 * Updates a team official's attendance to mark them as bringing refreshments.
 * @param gameId - The game ID
 * @param rosterId - The roster ID
 * @param teamOfficialId - The team official ID
 */
export const updateOfficialRefreshments = async (
  gameId: string,
  rosterId: string,
  teamOfficialId: string
): Promise<void> => {
  await req(
    `/games/${gameId}/rosters/${rosterId}/team-officials/${teamOfficialId}/attendance`,
    {
      method: 'PUT',
      body: JSON.stringify({
        bringing_refreshments: true,
      }),
    }
  )
}
